'use client';
import apiClient from './apiClient';

/** 會員相關 */
class AnaClient {
    // 取得熱門關鍵字
    getSearchKeywords = (locale) =>
        apiClient.get('/ana/search-option/18', {
            headers: {
                'X-LANG': 'zh-' + locale,
            },
        });

    // 建立 accessLog
    createAccessLog = (accessLog) =>
        apiClient.post('/ana/access-log', {
            accessLog,
        });
}

const anaClient = new AnaClient();

export default anaClient;
